'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = SpeedMenu;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _MenuHeader = require('../MenuHeader');

var _MenuHeader2 = _interopRequireDefault(_MenuHeader);

var _MenuOption = require('../MenuOption');

var _MenuOption2 = _interopRequireDefault(_MenuOption);

var _g11n = require('../../../shared/g11n');

var _g11n2 = _interopRequireDefault(_g11n);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var speeds = [0.5, 1, 1.5, 2, 2.5]; /**
                                     * Copyright 2013-2015, Hudl
                                     * All rights reserved.
                                     *
                                     * This source code is licensed under the BSD-style license found in the
                                     * LICENSE file in the root directory of this source tree. An additional grant
                                     * of patent rights can be found in the PATENTS file in the same directory.
                                     *
                                     * @providesModule SpeedMenu
                                     */

var normalSpeed = (0, _g11n2.default)('vi.player.menus.normal');
var speedLabel = (0, _g11n2.default)('vi.player.menus.speed');

function SpeedMenu(_ref) {
  var currentSpeed = _ref.currentSpeed,
      onHeaderClick = _ref.onHeaderClick,
      onOptionClick = _ref.onOptionClick;

  var speedDOMArray = speeds.map(function (speed) {
    var label = speed === 1 ? normalSpeed : speed + 'x';
    var key = 'Speed' + speed;

    return _react2.default.createElement(_MenuOption2.default, {
      key: key,
      onClick: onOptionClick.bind(null, speed),
      label: label,
      active: currentSpeed === speed
    });
  });

  return _react2.default.createElement(
    _MenuHeader2.default,
    { label: speedLabel, onClick: onHeaderClick },
    _react2.default.createElement(
      'ul',
      null,
      speedDOMArray
    )
  );
}

SpeedMenu.propTypes = {
  currentSpeed: _propTypes2.default.number,
  onHeaderClick: _propTypes2.default.func.isRequired,
  onOptionClick: _propTypes2.default.func.isRequired
};

SpeedMenu.displayName = 'SpeedMenu';
module.exports = exports['default'];